(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;

  const toast = $("#toast");
  const say = (msg) => {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add("show");
    clearTimeout(say.t);
    say.t = setTimeout(() => toast.classList.remove("show"), 3200);
  };

  let rules = { on: false, tag: "Free with your pack", packs: {}, sizes: {}, gifts: [] };
  try { const el = document.getElementById("rena-cart-rules"); if (el) rules = Object.assign(rules, JSON.parse(el.textContent)); } catch { /* keep the defaults */ }
  const post = async (url, body) => {
    const res = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || "The cart couldn't be updated.");
    return json;
  };
  const getCart = () => fetch("/cart.js", { headers: { Accept: "application/json" } }).then((r) => r.json());
  const isGift = (l) => !!(l.properties && l.properties._gift);
  const DRAWER = (document.getElementById("funnel-cart") || { dataset: {} }).dataset.section || "rena-cart-drawer";

  const sizes = rules.sizes || {};
  const boxesOf = (id) => Number((sizes[String(id)] || {}).boxes) || 0;
  const isPack = (l) => !isGift(l) && boxesOf(l.variant_id) > 0;
  const bestPacks = (n) => {
    const list = Object.entries(sizes).filter(([, s]) => s.available !== false && Number(s.boxes) > 0)
      .map(([id, s]) => ({ id: Number(id), boxes: Number(s.boxes), price: Number(s.price) })).sort((a, b) => b.boxes - a.boxes);
    const cost = [0], pick = [null];
    for (let i = 1; i <= n; i++) {
      cost[i] = Infinity; pick[i] = null;
      for (const s of list) if (s.boxes <= i && cost[i - s.boxes] + s.price < cost[i]) { cost[i] = cost[i - s.boxes] + s.price; pick[i] = s; }
    }
    if (n > 0 && !pick[n]) return null;
    const want = {};
    for (let i = n; i > 0; i -= pick[i].boxes) want[pick[i].id] = (want[pick[i].id] || 0) + 1;
    return want;
  };
  const giftText = (pos) => (rules.gifts || []).map((g) => [g, Number((g.qty || [])[pos - 1] || 0)]).filter(([, q]) => q > 0)
    .map(([g, q]) => (q === 1 ? g.label : `${q} ${g.plural || g.label}`)).join(" + ");

  const plan = (cart, boxes, lines) => {
    const items = cart.items, updates = {}, add = [];
    const packs = items.filter(isPack);
    const n = typeof boxes === "number" ? boxes : packs.reduce((s, l) => s + boxesOf(l.variant_id) * l.quantity, 0);
    const want = n > 0 ? bestPacks(n) : {};
    if (!want) throw new Error("That pack is sold out right now.");
    const note = !rules.on && packs.map((l) => Object.keys(l.properties || {}).find((k) => k[0] !== "_")).find(Boolean);
    const seen = new Set();
    for (const l of packs) {
      const q = seen.has(l.variant_id) ? 0 : want[l.variant_id] || 0;
      seen.add(l.variant_id);
      if (q !== l.quantity) updates[l.key] = q;
    }
    for (const [id, q] of Object.entries(want)) {
      if (!q || seen.has(Number(id))) continue;
      const text = note && giftText(rules.packs[id]);
      if (text) add.push({ id: Number(id), quantity: q, properties: { [note]: text } });
      else updates[id] = q;  // a new pack joins by its variant id, in the same update
    }
    Object.assign(updates, lines || {});
    if (rules.on && rules.gifts.length) {
      const top = Math.max(0, ...Object.keys(want).map(boxesOf)), gw = {};
      for (const [id, q] of Object.entries(want)) {
        if (!q || boxesOf(id) !== top) continue;
        const pos = rules.packs[String(id)];
        for (const g of rules.gifts) {
          const k = Number((g.qty || [])[pos - 1] || 0) * q;
          if (k > 0 && g.available !== false) gw[g.variant] = (gw[g.variant] || 0) + k;
        }
      }
      const giftLines = items.filter(isGift), done = new Set();
      for (const l of giftLines) {
        if (done.has(l.variant_id)) continue;
        done.add(l.variant_id);
        const same = giftLines.filter((x) => x.variant_id === l.variant_id), q = gw[l.variant_id] || 0;
        const keys = [...new Set(same.map((x) => x.key))];  // Shopify can list one line twice when two discounts share it
        if (keys.length === 1 && same.reduce((s, x) => s + x.quantity, 0) === q) continue;
        keys.forEach((key, i) => { updates[key] = i === 0 ? q : 0; });
      }
      for (const [id, q] of Object.entries(gw)) if (q > 0 && !done.has(Number(id))) add.push({ id: Number(id), quantity: q, properties: { _gift: rules.tag } });
    }
    return { updates, add };
  };
  const apply = async ({ updates, add }) => {
    let res = null;
    if (Object.keys(updates).length) res = await post("/cart/update.js", { updates, sections: [DRAWER] });
    if (add.length) res = await post("/cart/add.js", { items: add, sections: [DRAWER] });
    return res;
  };
  const show = (res) => { if (res && res.sections && window.FunnelCart && window.FunnelCart.render) window.FunnelCart.render(res.sections[DRAWER]); };
  const refreshDrawer = async (openIt) => {
    if (!window.FunnelCart) return;
    try { await window.FunnelCart.refresh(); } catch { /* the next open refreshes it */ }
    if (openIt) window.FunnelCart.open();
  };
  const sync = async () => { const res = await apply(plan(await getCart())); show(res); return !!res; };

  let cartNext = null, cartBusy = false, cartTimer = null;
  const queue = (change) => {
    cartNext = cartNext || { lines: {} };
    if (typeof change.boxes === "number") cartNext.boxes = change.boxes;
    Object.assign(cartNext.lines, change.lines || {});
    clearTimeout(cartTimer);
    cartTimer = setTimeout(flush, 220);
  };
  const flush = async () => {
    if (cartBusy || !cartNext) return;
    cartBusy = true;
    const job = cartNext;
    cartNext = null;
    try {
      const res = await apply(plan(await getCart(), job.boxes, job.lines));
      if (!cartNext) { if (res) show(res); else await refreshDrawer(false); }
    } catch (problem) {
      say(problem.message || "The cart couldn't be updated.");
      cartNext = null;
      await refreshDrawer(false);
    } finally {
      cartBusy = false;
      if (cartNext) flush();
    }
  };
  document.addEventListener("rena:changed", () => queue({}));
  const badge = document.querySelector("[data-cart-count]");
  if (badge && Number(badge.textContent) > 0) sync().catch(() => {});
  window.RenaGifts = { sync, rules, bestPacks, plan };

  const priceLike = (sample, cents) => {  // cents written the way the store writes the sample price
    const m = String(sample || "").match(/\d{1,3}(?:[.,\s']\d{3})*(?:([.,])\d{2})?/);
    if (!m) return null;
    const dec = m[1] || ".", th = dec === "," ? "." : ",", [i, f] = (Math.max(0, cents) / 100).toFixed(2).split(".");
    return sample.replace(m[0], i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (m[1] ? dec + f : ""));
  };
  const newTotal = (diff) => {  // the subtotal and the checkout button move by the same amount
    const tot = document.querySelector("#funnel-cart .fcd-total"), b = tot && tot.querySelector("b"), go = document.querySelector("#funnel-cart .rz-checkout span");
    if (!tot || !b || !diff) return;
    const cents = Number(tot.dataset.cents || 0) + diff;
    tot.dataset.cents = cents;
    b.textContent = priceLike(b.textContent, cents) || b.textContent;
    if (go) go.textContent = priceLike(go.textContent, cents) || go.textContent;
  };
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("#funnel-cart [data-cart-boxes]");  // not the buy box's packs, which carry data-boxes
    if (!btn) return;
    e.preventDefault();
    const row = btn.closest(".rz-pack"), num = row && row.querySelector(".fcd-qty span");
    const n = Math.max(0, Math.min(Number((row && row.dataset.max) || 99), Number(btn.dataset.cartBoxes) || 0));
    if (row) {
      row.classList.add("is-updating");
      if (num) num.textContent = n;
      row.querySelectorAll("[data-step]").forEach((b) => { b.dataset.cartBoxes = Math.max(0, n + Number(b.dataset.step)); });
      const want = n ? bestPacks(n) : {};
      if (want) {
        const cents = Object.entries(want).reduce((t, [id, q]) => t + Number((sizes[id] || {}).price || 0) * q, 0);
        const price = row.querySelector(".rz-item-price b"), each = row.querySelector(".rz-each");
        if (price) price.textContent = priceLike(price.textContent, cents) || price.textContent;
        if (each) { each.textContent = priceLike(each.textContent, Math.floor(cents / Math.max(1, n))) || each.textContent; each.hidden = n < 2; }
        newTotal(cents - Number(row.dataset.cents || cents));
        row.dataset.cents = cents;
      }
      if (n === 0) row.hidden = true;
    }
    queue({ boxes: n });
  });
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("#funnel-cart [data-line][data-key]");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();  // this script sends every cart change, so the drawer script doesn't send its own
    const q = Math.max(0, Number(btn.dataset.qty) || 0), item = btn.closest(".rz-item");
    if (item) {
      item.classList.add("is-updating");
      const num = item.querySelector(".fcd-qty span");
      if (num) num.textContent = q;
      item.querySelectorAll("[data-step]").forEach((b) => { b.dataset.qty = Math.max(0, q + Number(b.dataset.step)); });
      const unit = Number(item.dataset.unit), price = item.querySelector(".rz-item-price b"), was = Number(item.dataset.cents || 0);
      if (unit >= 0 && price && item.dataset.unit) {
        price.textContent = priceLike(price.textContent, unit * q) || price.textContent;
        newTotal(unit * q - was);
        item.dataset.cents = unit * q;
      }
      if (q === 0) item.hidden = true;
    }
    queue({ lines: { [btn.dataset.key]: q } });
  }, true);

  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-upsell-add]");
    if (!btn) return;
    const card = btn.closest("[data-upsell]"), pick = card && card.querySelector("[data-upsell-variant]");
    if (!pick || !pick.value) return;
    btn.setAttribute("aria-busy", "true");
    try {
      show(await post("/cart/add.js", { items: [{ id: Number(pick.value), quantity: 1 }], sections: [DRAWER] }));
    } catch (problem) {
      say(problem.message);
    } finally {
      btn.removeAttribute("aria-busy");
    }
  });

  const vis = new IntersectionObserver((entries) => entries.forEach((e) => {
    if (e.isIntersecting) e.target.play().catch(() => {}); else e.target.pause();
  }), { threshold: 0.35 });
  $$(".frame video").forEach((v) => { v.muted = true; vis.observe(v); });

  const main = $("#g-main");
  if (main) {
    const slides = [...main.children].filter((el) => !el.classList.contains("g-cap") && !el.classList.contains("slot-ph"));
    const thumbs = $$("#g-thumbs button");
    const cap = $(".g-cap", main);
    const show = (i) => {
      slides.forEach((s, j) => {
        s.classList.toggle("on", j === i);
        if (s.tagName === "VIDEO") { if (j === i) { s.muted = true; s.play().catch(() => {}); } else s.pause(); }
      });
      thumbs.forEach((t, j) => t.classList.toggle("on", j === i));
      if (cap && slides[i]) { cap.textContent = slides[i].dataset.caption || ""; cap.hidden = !cap.textContent; }
    };
    thumbs.forEach((t, i) => t.addEventListener("click", () => show(i)));
    if (slides.length) show(0);
    let x0 = null;  // swipe on phones
    main.addEventListener("touchstart", (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener("touchend", (e) => {
      if (x0 === null || slides.length < 2) return;
      const dx = e.changedTouches[0].clientX - x0, cur = slides.findIndex((s) => s.classList.contains("on"));
      if (Math.abs(dx) > 40) show((cur + (dx < 0 ? 1 : -1) + slides.length) % slides.length);
      x0 = null;
    });
  }

  const form = $("[data-rena-form]");
  const dataEl = $("[data-rena-offer]");
  let data = {};
  try { data = dataEl ? JSON.parse(dataEl.textContent) : {}; } catch { data = {}; }
  const fmt = String(data.money_format || "${{amount}}").replace(/<[^>]*>/g, "");
  const money = (cents) => {
    const n = (Number(cents) || 0) / 100;
    const group = (dec, th, ds) => { const [i, f] = n.toFixed(dec).split("."); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? ds + f : ""); };
    const forms = {
      amount: () => group(2, ",", "."), amount_no_decimals: () => group(0, ",", "."),
      amount_with_comma_separator: () => group(2, ".", ","), amount_no_decimals_with_comma_separator: () => group(0, ".", ","),
      amount_with_apostrophe_separator: () => group(2, "'", "."), amount_with_space_separator: () => group(2, " ", ","),
      amount_with_period_and_space_separator: () => group(2, " ", "."),
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => (forms[key] || forms.amount)());
  };
  const short = (cents) => money(cents).replace(/[.,]00(?=\D*$)/, "");

  if (form) {
    const tiers = $$(".tier", form);
    const idInput = document.createElement("input");
    Object.assign(idInput, { type: "hidden", name: "id" });
    tiers.forEach((t) => { const r = $("input[type=radio]", t); if (r) r.name = "pack"; });  // the hidden id is what Shopify reads
    if (tiers.length) form.prepend(idInput);
    const giftBox = $("#rena-gifts"), giftList = $("#gift-list"), prop = $("#rena-gift-prop");
    const addon = $("#addon"), total = $("#total"), atc = $("#add-to-cart"), atcLabel = $("[data-atc-label]", form);
    const upCheck = $("#upsell-check"), upVar = $("#upsell-variant"), upPriceEl = $("#upsell-price");
    const upPrice = () => (upVar ? Number(upVar.tagName === "SELECT" ? upVar.selectedOptions[0].dataset.price : upVar.dataset.price) : 0);
    const stickyText = $("#sticky-text");
    const atcText = atcLabel ? atcLabel.textContent : "Add to cart";
    const propName = prop ? (prop.name.match(/^properties\[(.*)\]$/) || [])[1] : "";
    let cur = tiers.find((t) => t.classList.contains("on") && !t.classList.contains("soldout")) || tiers.find((t) => !t.classList.contains("soldout")) || tiers[0];

    const giftsFor = (pos) => (pos > 0 ? rules.gifts || [] : []).map((g) => ({ g, qty: Number((g.qty || [])[pos - 1] || 0) })).filter((x) => x.qty > 0)
      .map(({ g, qty }) => ({ icon: g.icon, qty, name: qty === 1 ? g.label : `${qty} ${g.plural || g.label}`, value: (Number(g.value) || 0) * qty }));
    const VB = { drop: "0 0 100 100" };
    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

    const render = () => {
      const pos = cur && rules.packs[cur.dataset.variant] ? Number(cur.dataset.position) : 0;
      tiers.forEach((t) => {
        const on = t === cur;
        t.classList.toggle("on", on);
        t.setAttribute("aria-checked", String(on));
        const r = $("input[type=radio]", t);
        if (r) r.checked = on;
      });
      if (cur) idInput.value = cur.dataset.variant;
      const gifts = giftsFor(pos);
      if (giftBox) {
        giftBox.hidden = !gifts.length;
        const worth = gifts.reduce((s, x) => s + x.value, 0);
        const note = String(data.gifts_note || "");
        const noteHtml = note && (worth > 0 || !note.includes("[value]")) ? `<li><span class="val" style="margin-left:0">${esc(note).replace("[value]", `<b>${esc(short(worth))}</b>`)}</span></li>` : "";
        giftList.innerHTML = gifts.map((x) => `<li><svg viewBox="${VB[x.icon] || "0 0 80 80"}" aria-hidden="true"><use href="#${x.icon}"/></svg><span>${esc(x.name)}</span><span class="val">${x.value > 0 ? `<s>${esc(short(x.value))}</s>` : ""}<b>Free</b></span></li>`).join("") + noteHtml;
      }
      if (prop) { prop.value = gifts.map((x) => x.name).join(" + "); prop.disabled = !prop.value; }
      if (upPriceEl && upVar) upPriceEl.textContent = money(upPrice());
      const price = (cur ? Number(cur.dataset.price) : 0) + (addon && addon.checked ? Number(addon.dataset.price) : 0) + (upCheck && upCheck.checked ? upPrice() : 0);
      if (total) total.textContent = money(price);
      const soldOut = cur && cur.classList.contains("soldout");
      if (atc) atc.disabled = !!soldOut;
      if (atcLabel) atcLabel.textContent = soldOut ? "Sold out" : atcText;
      const sizeTag = cur && cur.dataset.size ? `${cur.dataset.size} · ` : "";
      if (stickyText && cur) stickyText.innerHTML = `<b>${esc(sizeTag + $(".t-name", cur).textContent)}</b> · ${esc(money(price))}${soldOut ? " · sold out" : ""}`;
    };
    tiers.forEach((t) => t.addEventListener("click", (e) => {
      if (t.classList.contains("soldout")) { e.preventDefault(); return; }
      cur = t; render();
    }));
    // size buttons: show the picked size's packs and keep the same pack position
    const sizePick = $("[data-size-pick]", form), sizeName = $("[data-size-name]", form);
    if (sizePick) sizePick.addEventListener("change", (e) => {
      const size = e.target.value;
      $$(".size-pill", sizePick).forEach((p) => p.classList.toggle("on", $("input", p) === e.target));
      if (sizeName) sizeName.textContent = size;
      const shown = tiers.filter((t) => t.dataset.size === size);
      tiers.forEach((t) => { t.hidden = t.dataset.size !== size; });
      const pos = cur ? cur.dataset.position : "1";
      cur = shown.find((t) => t.dataset.position === pos && !t.classList.contains("soldout")) || shown.find((t) => !t.classList.contains("soldout")) || shown[0];
      render();
    });
    if (addon) addon.addEventListener("change", render);
    [upCheck, upVar].forEach((el) => { if (el) el.addEventListener("change", render); });

    let busy = false;
    const add = async () => {
      if (busy || !cur || cur.classList.contains("soldout")) return;
      busy = true;
      if (atc) atc.setAttribute("aria-busy", "true");
      const item = { id: Number(cur.dataset.variant), quantity: 1 };
      const giftLines = rules.on && rules.gifts.length > 0;
      if (!giftLines && prop && !prop.disabled && propName) item.properties = { [propName]: prop.value };
      const items = [item];
      if (addon && addon.checked) items.push({ id: Number(addon.dataset.variant), quantity: 1 });
      if (upCheck && upCheck.checked && upVar && upVar.value) items.push({ id: Number(upVar.value), quantity: 1 });
      try {
        const added = await post(data.cart_add || "/cart/add.js", { items, sections: [DRAWER] });
        const res = await apply(plan(await getCart()));  // the cheapest packs for all the boxes in the cart, and their gifts
        if (data.after_add === "checkout") { location.href = data.checkout || "/checkout"; return; }
        show(res || added);
        if (window.FunnelCart) window.FunnelCart.open();
      } catch (problem) {
        say(problem.message || "That couldn't be added to your cart.");
      } finally {
        busy = false;
        if (atc) atc.removeAttribute("aria-busy");
      }
    };
    form.addEventListener("submit", (e) => { e.preventDefault(); add(); });
    const sb = $("#sticky-btn");
    if (sb) sb.addEventListener("click", (e) => { e.preventDefault(); add(); });
    render();
    window.RenaOffer = { render, add, pick: (i) => { if (tiers[i] && !tiers[i].classList.contains("soldout")) { cur = tiers[i]; render(); } } };
  }

  const sticky = $("#sticky");
  const anchor = $("#buy") || ($("[data-sticky-home]") && $("main .shopify-section"));
  if (sticky && anchor) {
    new IntersectionObserver(([e]) => {
      const on = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle("show", on);
      document.documentElement.classList.toggle("sticky-on", on);
    }, { threshold: 0 }).observe(anchor);
  }

  let frame = null, pending = null;
  const signup = (f) => {
    if (!frame) {
      frame = document.createElement("iframe");
      Object.assign(frame, { name: "rena-signup", title: "Email sign-up", hidden: true, tabIndex: -1 });
      frame.setAttribute("aria-hidden", "true");
      document.body.appendChild(frame);
      frame.addEventListener("load", () => {
        const sent = pending;
        pending = null;
        if (!sent) return;
        let href = "";
        try { href = frame.contentWindow.location.href; } catch { /* not ours to read */ }
        if (/\/challenge/.test(href)) { sent.target = "_self"; sent.submit(); }
      });
    }
    f.target = "rena-signup";
    pending = f;
    return true;
  };

  const pop = $(".scratch-pop");
  if (pop) {
    const KEY = "rena-scratch";
    const store = {
      get() { try { const v = localStorage.getItem(KEY); return v === null ? null : JSON.parse(v); } catch { return null; } },
      set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch { /* private mode */ } },
    };
    const session = {
      get() { try { return sessionStorage.getItem(KEY) === "1"; } catch { return false; } },
      set() { try { sessionStorage.setItem(KEY, "1"); } catch { /* private mode */ } },
    };
    const teaser = $(".sp-teaser");
    const box = $(".sp-box", pop), card = $(".sp-card", pop), cv = $("canvas", card), ctx = cv.getContext("2d");
    const force = /[?&]popup=1\b/.test(location.search);
    const delay = Math.max(3, Number(pop.dataset.delay) || 8) * 1000;
    const blocked = () => { const v = store.get(); return v === "claimed" || (typeof v === "number" && Date.now() - v < 7 * 864e5); };
    let lastFocus = null, revealed = false, started = false, W = 0, H = 0;
    const paint = () => {
      W = cv.offsetWidth; H = cv.offsetHeight;
      const dpr = Math.min(2, window.devicePixelRatio || 1);
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.globalCompositeOperation = "source-over";
      const g = ctx.createLinearGradient(0, 0, W, H);
      g.addColorStop(0, "#294B3A"); g.addColorStop(1, "#1E3529");
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
      let seed = 7;
      const rnd = () => (seed = (seed * 16807) % 2147483647) / 2147483647;
      for (let i = 0; i < W * H * 0.09; i++) {
        ctx.fillStyle = rnd() < 0.5 ? "rgba(255,244,224,.16)" : "rgba(0,0,0,.28)";
        ctx.fillRect(rnd() * W, rnd() * H, 1 + rnd() * 1.4, 1 + rnd() * 1.4);
      }
      ctx.fillStyle = "#EAF0E8"; ctx.textAlign = "center"; ctx.textBaseline = "middle";
      ctx.font = "800 23px Oswald, Georgia, serif"; ctx.fillText(pop.dataset.cardTitle || "Scratch here", W / 2, H / 2 - 12);
      ctx.fillStyle = "rgba(255,244,224,.82)";
      ctx.font = "700 13px 'Nunito Sans', sans-serif"; ctx.fillText(pop.dataset.cardSub || "with your finger or mouse", W / 2, H / 2 + 16);
      ctx.globalCompositeOperation = "destination-out";
    };
    const at = (e) => { const r = cv.getBoundingClientRect(); return [(e.clientX - r.left) * W / r.width, (e.clientY - r.top) * H / r.height]; };
    let down = false, last = null, checkedAt = 0;
    const claw = ([x, y]) => {
      ctx.lineWidth = 12; ctx.lineCap = "round"; ctx.lineJoin = "round";
      if (!last) { [-14, 0, 14].forEach((o) => { ctx.beginPath(); ctx.arc(x + o, y, 6, 0, 7); ctx.fill(); }); last = [x, y]; return; }
      const dx = x - last[0], dy = y - last[1], len = Math.hypot(dx, dy) || 1, nx = -dy / len, ny = dx / len;
      [-14, 0, 14].forEach((o) => { ctx.beginPath(); ctx.moveTo(last[0] + nx * o, last[1] + ny * o); ctx.lineTo(x + nx * o, y + ny * o); ctx.stroke(); });
      last = [x, y];
    };
    const cleared = () => {
      const d = ctx.getImageData(0, 0, cv.width, cv.height).data;
      let n = 0, clear = 0;
      for (let i = 3; i < d.length; i += 4 * 37) { n++; if (d[i] < 100) clear++; }
      return n ? clear / n : 0;
    };
    const burst = () => {
      if (reduce) return;
      const b = $(".sp-burst", pop), r = card.getBoundingClientRect();
      b.style.left = r.left + r.width / 2 + "px"; b.style.top = r.top + r.height / 2 + "px";
      const colors = ["#DB826A", "#EAF0E8", "#294B3A", "#C46A53", "#F8E8E2"];
      for (let k = 0; k < 22; k++) {
        const i = document.createElement("i"), a = Math.random() * Math.PI * 2, d = 90 + Math.random() * 140;
        i.innerHTML = '<svg viewBox="0 0 100 100"><use href="#drop"/></svg>';
        i.style.cssText = `color:${colors[k % colors.length]};--x:${Math.cos(a) * d}px;--y:${Math.sin(a) * d - 40}px;--r:${Math.random() * 360 - 180}deg`;
        b.appendChild(i);
        setTimeout(() => i.remove(), 1250);
      }
    };
    const reveal = () => {
      if (revealed) return;
      revealed = true;
      pop.classList.add("revealed");
      burst();
      try { navigator.vibrate && navigator.vibrate(25); } catch { /* no haptics */ }
      if (window.matchMedia && matchMedia("(pointer: fine)").matches) setTimeout(() => $("#sp-email", pop).focus({ preventScroll: true }), 350);
    };
    const check = () => { if (!revealed && cleared() > 0.42) reveal(); };
    cv.addEventListener("pointerdown", (e) => {
      if (revealed) return;
      down = true; last = null;
      if (!started) { started = true; pop.classList.add("started"); }
      try { cv.setPointerCapture(e.pointerId); } catch { /* ok */ }
      claw(at(e));
    });
    cv.addEventListener("pointermove", (e) => {
      if (!down) return;
      claw(at(e));
      const t = performance.now();
      if (t - checkedAt > 160) { checkedAt = t; check(); }
    });
    const up = () => { if (!down) return; down = false; last = null; check(); };
    ["pointerup", "pointercancel", "lostpointercapture"].forEach((ev) => cv.addEventListener(ev, up));
    $(".sp-reveal", pop).addEventListener("click", reveal);
    addEventListener("resize", () => { if (!pop.hidden && !started && !revealed) paint(); });

    const focusables = () => $$("button, a[href], input", box).filter((el) => el.offsetParent !== null);
    const open = () => {
      if (!pop.hidden) return;
      pop.hidden = false;
      session.set();
      lastFocus = document.activeElement;
      document.documentElement.classList.add("sp-lock");
      if (teaser) teaser.hidden = true;
      requestAnimationFrame(() => {
        pop.classList.add("on");
        if (!started && !revealed) (document.fonts ? document.fonts.load("800 23px Oswald") : Promise.resolve()).then(paint, paint);
      });
      setTimeout(() => $(".sp-close", pop).focus({ preventScroll: true }), 60);
    };
    const close = () => {
      if (pop.hidden) return;
      pop.classList.remove("on");
      document.documentElement.classList.remove("sp-lock");
      setTimeout(() => { pop.hidden = true; }, 260);
      if (store.get() !== "claimed") { store.set(Date.now()); if (teaser) teaser.hidden = false; }
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };
    $(".sp-close", pop).addEventListener("click", close);
    $(".sp-no", pop).addEventListener("click", close);
    let downOnBackdrop = false;  // only a click that starts on the backdrop closes it, not a scratch that ends there
    pop.addEventListener("pointerdown", (e) => { downOnBackdrop = e.target === pop; });
    pop.addEventListener("click", (e) => { if (e.target === pop && downOnBackdrop) close(); downOnBackdrop = false; });
    document.addEventListener("keydown", (e) => {
      if (pop.hidden) return;
      if (e.key === "Escape") { close(); return; }
      if (e.key !== "Tab") return;
      const f = focusables();
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    const signForm = $("[data-scratch-form]", pop);
    if (signForm) signForm.addEventListener("submit", (e) => {
      const input = $("#sp-email", pop);
      const ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim());
      input.setAttribute("aria-invalid", String(!ok));
      if (!ok) { e.preventDefault(); input.focus(); return; }
      signup(signForm);  // the form posts into the hidden frame
      pop.classList.add("claimed");
      store.set("claimed");
      if (teaser) teaser.hidden = true;
      const done = $(".sp-done .btn", pop);
      if (done) setTimeout(() => done.focus({ preventScroll: true }), 50);
    });
    const cta = $(".sp-done .btn", pop);
    if (cta) cta.addEventListener("click", (e) => {
      const url = new URL(cta.getAttribute("href") || "", location.href);
      close();
      if (url.pathname !== location.pathname) return;
      e.preventDefault();
      history.replaceState(null, "", url.hash || "#buy");
      const target = document.getElementById((url.hash || "#buy").slice(1));
      if (target) setTimeout(() => target.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" }), 280);
    });
    if (teaser) {
      teaser.addEventListener("click", open);
      if (typeof store.get() === "number") teaser.hidden = false;
    }
    if (force) setTimeout(open, 400);
    else if (!blocked() && !session.get() && !window.Shopify?.designMode) {
      const auto = () => { if (!blocked() && !session.get()) open(); };
      const timer = setTimeout(auto, delay);
      const onScroll = () => {
        const h = document.documentElement.scrollHeight - innerHeight;
        if (h > 0 && scrollY / h > 0.45) { removeEventListener("scroll", onScroll); clearTimeout(timer); auto(); }
      };
      addEventListener("scroll", onScroll, { passive: true });
      if (window.matchMedia && matchMedia("(pointer: fine)").matches) {
        document.addEventListener("mouseout", (e) => { if (!e.relatedTarget && e.clientY <= 0) { clearTimeout(timer); auto(); } });
      }
    }
    document.addEventListener("shopify:section:select", (e) => { if (e.target.contains(pop)) open(); });
    document.addEventListener("shopify:section:deselect", (e) => { if (e.target.contains(pop)) close(); });
  }
})();
